import React from 'react'
import lucide from './lucide.svg'
import './icons.css'

type LucideId =
  | 'arrow-up'
  | 'arrow-down'
  | 'arrow-down-up'
  | 'play'
  | 'pencil'
  | 'cog'
  | 'trash'
  | 'eraser'
  | 'rotate-ccw'
  | 'rotate-cw'
  | 'funnel'
  | 'grid-2x2-x'
  | 'view'

export type LucideRef = `lucide#${LucideId}`

export type IconRef = LucideRef

const sprites: Record<string, string> = {
  lucide,
}

interface IconProps extends React.ComponentProps<'svg'> {
  use: IconRef
}

export const Icon = ({ use, ...props }: IconProps) => {
  const split = use.indexOf('#')
  const sprite = sprites[use.slice(0, split)]
  const id = use.slice(split + 1)
  return (
    <svg data-component="icon" color="#337ab7" {...props}>
      <use href={`${sprite}#${id}`} />
    </svg>
  )
}
